/**
 * The desktop viewport width the capture iframe is sized to (matches the
 * width declared by `VIEWPORT_INJECTION`'s viewport meta). Picked at
 * 1280px because that lands above the typical `768px` / `1024px`
 * mobile/tablet breakpoints agent-generated pages use, so we always
 * render the desktop branch.
 *
 * Exported so callers (PageRowThumbnail, PageRenderer's OG capture path)
 * size their off-screen iframes to the same width without duplicating
 * the magic number.
 */
export const THUMBNAIL_VIEWPORT_W = 1280;
/**
 * 4:3 source viewport height (1280 × 0.75) — matches the 288×216 list
 * thumbnail aspect ratio so html-to-image's stretch-to-canvas behaviour
 * doesn't distort the captured pixels.
 */
/**
 * 1.91:1 source viewport height (1280 / 1.905 ≈ 672) — matches the
 * 1200×630 OG canvas aspect ratio so html-to-image doesn't squash or
 * letterbox the OG image.
 */
export const THUMBNAIL_VIEWPORT_H_OG = 672;
